(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["survival-complete-fits"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('survival-fits'))customElements.define('survival-fits',class extends HTMLElement{
connectedCallback(){
this.abort=new AbortController();const signal=this.abort.signal;this.track=this.querySelector('.sfit__track');
this.addEventListener('click',event=>{
const opener=event.target.closest('[data-open]');if(opener){const dialog=document.getElementById(opener.dataset.open);if(!dialog)return;event.preventDefault();this.opener=opener;dialog.showModal();if(opener.dataset.focus)dialog.querySelector('#'+CSS.escape(opener.dataset.focus))?.focus();}
const close=event.target.closest('[data-close]');if(close)close.closest('dialog').close();
const arrow=event.target.closest('[data-step]');if(arrow){const card=this.track.querySelector('.sfit__card');this.track.scrollBy({left:Number(arrow.dataset.step)*(card.getBoundingClientRect().width+16),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});}
if(event.target.tagName==='DIALOG'){const box=event.target.getBoundingClientRect();if(event.clientX<box.left||event.clientX>box.right||event.clientY<box.top||event.clientY>box.bottom)event.target.close();}
},{signal});
this.querySelectorAll('dialog').forEach(dialog=>dialog.addEventListener('close',()=>this.opener?.focus(),{signal}));
this.updateArrows=()=>{const max=this.track.scrollWidth-this.track.clientWidth;this.querySelector('[data-step="-1"]').disabled=this.track.scrollLeft<2;this.querySelector('[data-step="1"]').disabled=this.track.scrollLeft>=max-2;};this.track.addEventListener('scroll',this.updateArrows,{signal,passive:true});this.resize=new ResizeObserver(this.updateArrows);this.resize.observe(this.track);this.updateArrows();
}
disconnectedCallback(){this.abort?.abort();this.resize?.disconnect();this.querySelectorAll('dialog[open]').forEach(d=>d.close());}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["survival-editorial-grid"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('survival-grid-tile')) {
    customElements.define('survival-grid-tile', class extends HTMLElement {
      connectedCallback() {
        const video = this.querySelector('video');
        const button = this.querySelector('.survival-edit__playback');
        if (!video || !button || this.controller) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        let manualPause = false;
        let visible = false;
        video.muted = true;
        button.hidden = false;
        const updateButton = () => {
          button.setAttribute('aria-pressed', String(!video.paused));
          button.querySelector('span').textContent = video.paused ? '▶' : 'Ⅱ';
        };
        const play = () => video.play().catch(updateButton);
        const sync = () => {
          if (visible && !document.hidden && !motion.matches && !manualPause) play();
          else video.pause();
        };
        video.addEventListener('play', updateButton, options);
        video.addEventListener('pause', updateButton, options);
        button.addEventListener('click', () => {
          if (video.paused) { manualPause = false; play(); }
          else { manualPause = true; video.pause(); }
        }, options);
        motion.addEventListener('change', sync, options);
        document.addEventListener('visibilitychange', sync, options);
        this.observer = new IntersectionObserver(entries => {
          visible = entries[0].isIntersecting;
          sync();
        }, { threshold: 0.1 });
        this.observer.observe(this);
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.controller?.abort();
        this.controller = null;
        this.querySelector('video')?.pause();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["survival-shipping-marquee"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('survival-shipping-marquee'))customElements.define('survival-shipping-marquee',class extends HTMLElement{
connectedCallback(){this.abort=new AbortController();this.addEventListener('click',event=>{const button=event.target.closest('button');if(!button)return;const paused=this.toggleAttribute('data-paused');button.setAttribute('aria-pressed',String(paused));button.querySelector('span').textContent=paused?'▶':'Ⅱ';},{signal:this.abort.signal});}
disconnectedCallback(){this.abort?.abort();}
});

  } catch(e) { console.error(e); }
})();
})();
